module.exports = __webpack_public_path__ + "static/media/log_hero_logo.cecf024f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/log_hero_logo.png
// module id = 333
// module chunks = 0